import React from "react";
import { createRoot } from "react-dom/client";
import Subscription from "./Subscription";

declare global {
	interface Window {
		renderSubscribe: unknown;
	}
}

export function renderSubscribe(rootId: string, reCaptchaKey: string, isChinaUser: boolean) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(<Subscription reCaptchaKey={reCaptchaKey} isChinaUser={isChinaUser} />);
}

window.renderSubscribe = renderSubscribe;
